import { formatDate } from 'util/date/formatDate'

import { CidadaoAtestado } from '../components/model-atestado'
import { buildCpfCnsSubstring, buildDocumentoSubstring, buildNomeSubstring } from '../utils-atestado'

export const getLicencaMaternidadeText = (
  cidadao: CidadaoAtestado,
  cpfCns: string | undefined,
  naoPossui: boolean | undefined,
  dataAfastamento: LocalDate | undefined
): string => {
  const nome = buildNomeSubstring(cidadao)
  const documento = buildCpfCnsSubstring(cidadao, cpfCns, naoPossui)
  const documentoSubstring = buildDocumentoSubstring(documento)

  return (
    `Atesto, para os fins de licença maternidade, que ${nome.titleCase()}${documentoSubstring} ` +
    `necessita de afastamento de suas atividades laborativas ` +
    `a partir do dia ${formatDate(dataAfastamento)}.`
  )
}
